import React from 'react';

import { SectionDivider } from '~/components/SectionDividor';
import { OFFERS_ROUTER } from '~/constants/router';
import { useLinkComponent } from '~/hooks/mobileApp';
import PopularProductList from '~/pages/app/components/PopularProducts/PopularProductList';

import { MoreIcon } from '~/assets/icons';
import { DataErrorImg } from '~/assets/img/common';

const FrequentlyOrderedDefaultView = () => {
  const LinkComponent = useLinkComponent();

  return (
    <>
      <div className="flex flex-col items-center py-40 text-center">
        <img src={DataErrorImg.src} className="size-64" alt="error guide" />
        <h2 className="mt-8 typo-title100-semibold">
          자주 구매한 상품이 없어요.
        </h2>
        <p className="mt-4 text-hint typo-caption100-regular">
          다양한 상품을 둘러보고 구매해보세요.
        </p>
      </div>

      <SectionDivider />
      <div className="my-24 pb-24">
        <div className="mb-16 flex items-center justify-between px-20">
          <h2 className="text-paragraph typo-heading100">실시간 BEST 상품</h2>
          <LinkComponent
            href={`${OFFERS_ROUTER.popularShowcase}?categoryId=0`}
            className="ml-8 shrink-0"
          >
            <span className="flex items-center text-blue-800 typo-paragraph100-regular">
              전체보기
              <MoreIcon />
            </span>
          </LinkComponent>
        </div>
        <PopularProductList />
      </div>
    </>
  );
};

export default FrequentlyOrderedDefaultView;
